// NPM Imports
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { Button } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Import
import CreateTemplatePopup from "../../CreateTemplatePopup";
// import TemplateHeaderSearch from "./TemplateHeaderSearch";
// Internal Imports
import withRbac from "../../../app/withRbac";
import { PERMISSIONS } from "../../../constants";
import TemplateHeaderSearch from "./TemplateHeaderSearch";

// Destructuring
class TemplateHeader extends Component {
  state = {
    showCreateTemplatePopUp: false,
  };

  _toggleTemplatePopUp = () => {
    this.setState(prevState => ({
      showCreateTemplatePopUp: !prevState.showCreateTemplatePopUp,
    }));
  };

  render() {
    // CREATE BTN DISPLAY BASED ON RBAC
    const CreateNewTemplateBtn = withRbac(() => (
      <Button
        data-test="listdoctemplates-create-new-template-button"
        className="btn btn-primary createdropdown-btn"
        onClick={this._toggleTemplatePopUp}>
        <i>
          <FontAwesomeIcon icon={["far", "plus"]} />
        </i>
        Create template
      </Button>
    ));
    const {
      type,
      showSearchPage,
      toggleSearchPage,
      togglePreview,
    } = this.props;
    return (
      <Fragment>
        <div className="templateheader-container">
          {/* SEARCH BAR SECTION */}
          <div className="templateheader-title-wrapper">
            <div className="templateheader-title">My Templates</div>
            <div className="templateheader-subtitle">
              All templates created in or added to your Revv org are listed here
            </div>
          </div>
          <TemplateHeaderSearch
            key={type}
            type={type}
            showSearchPage={showSearchPage}
            toggleSearchPage={toggleSearchPage}
            togglePreview={togglePreview}
          />
          {/** CREATE TEMPLATE BTN SECTION */}
          <div className="create-container">
            <CreateNewTemplateBtn
              permission={PERMISSIONS.TEMPLATES.UPDATE_TEMPLATES}
            />
          </div>
        </div>

        {/** CREATE TEMPLATE POPUP COMPONENT */}
        {this.state.showCreateTemplatePopUp && (
          <CreateTemplatePopup closePopUp={this._toggleTemplatePopUp} />
        )}
      </Fragment>
    );
  }
}

TemplateHeaderSearch.propTypes = {
  type: PropTypes.string.isRequired,
  toggleSearchPage: PropTypes.func.isRequired,
  togglePreview: PropTypes.func.isRequired,
};

export default TemplateHeader;



// WEBPACK FOOTER //
// ./src/components/TemplateV2/TemplateHeader/index.js